import { render, staticRenderFns } from "./Boats.vue?vue&type=template&id=17ee7d6d"
import script from "./Boats.vue?vue&type=script&lang=js"
export * from "./Boats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports